jQuery(document).ready(function($) {

	var isotope_container = $('.products-list-design #boxes_grid');
	isotope_container.imagesLoaded(function(){
		isotope_container.isotope({
			itemSelector: '.grid-item',
			percentPosition: true,
			masonry: {
				columnWidth: '.grid-sizer'
			}
		})
	});


	$('.product-slider .slick').slick({
		dots: true,
		nav: false,
		arrows: true,
		adaptiveHeight: false,
		infinite: true,
		fade: true,
		prevArrow: '<span class="slick-prev hidden-xs hidden-sm hidden-md"><span class="glyphicon glyphicon-menu-left"></span></span>',
		nextArrow: '<span class="slick-next hidden-xs hidden-sm hidden-md"><span class="glyphicon glyphicon-menu-right"></span></span>',
	});
	$('.product-slider .slick .slick-dots > li').each(function(){
		$(this).find('button').text( 0 + $(this).find('button').text() );
	});

	$('.slider-finiture .slick').slick({
		dots: false,
		nav: false,
		arrows: true,
		adaptiveHeight: false,
		infinite: true,
		fade: false,
		prevArrow: '<span class="slick-prev"><span class="glyphicon glyphicon-menu-left"></span></span>',
		nextArrow: '<span class="slick-next"><span class="glyphicon glyphicon-menu-right"></span></span>',
		slidesToShow: 1,
		slidesToScroll: 1,
		centerMode: true,
 		variableWidth: true
	});
	$('#modal_finiture').on('shown.bs.modal', function (e) {
		$('.slider-finiture .slick').resize();
	});

	$('#modal_registration .custom-select').SumoSelect();

	if( isBreakpoint('xs') ){
		$('.product-extras .slick').slick({
			dots: true,
			nav: false,
			arrows: false,
			adaptiveHeight: true,
			infinite: true,
			fade: true
		});
	}

	$('.product-related .products .slick').slick({
		dots: true,
		nav: false,
		arrows: false,
		adaptiveHeight: false,
		infinite: false,
		slidesToShow: 3,
		slidesToScroll: 3,
		centerMode: false,
		responsive: [
			{
				breakpoint: 768,
				settings: {
					dots: false,
					centerMode: true,
					slidesToShow: 1,
					slidesToScroll: 1
				}
			}
		]
	});

	$('.product-related .case-study .slick').slick({
		dots: true,
		nav: false,
		arrows: true,
		adaptiveHeight: false,
		infinite: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		centerMode: false,
		prevArrow: '<span class="slick-prev hidden-xs hidden-sm hidden-md"><span class="glyphicon glyphicon-menu-left"></span></span>',
		nextArrow: '<span class="slick-next hidden-xs hidden-sm hidden-md"><span class="glyphicon glyphicon-menu-right"></span></span>',
		responsive: [
			{
				breakpoint: 768,
				settings: {
					dots: true,
					centerMode: false,
					slidesToShow: 1,
					slidesToScroll: 1
				}
			}
		]
	});


	$('.modal_documenti').on('shown.bs.modal', function (e) {
		if( isBreakpoint('lg') ){
			var myTrigger = 'hover';
		}
		else{
			var myTrigger = 'click';
		}

		$('.modal-table .table tbody tr td .preview-tooltip').tooltipster({
			arrow: false,
			contentCloning: true,
			side: ['left'],
			trigger: myTrigger,
			theme: 'tooltipster-shadow'
		});
	});

	if( $('.product-detail').height() < $('.product-detail .vertical-label > span').width() ){
		$('.product-detail').height( $('.product-detail .vertical-label > span').width() )
	}
});

jQuery(window).resize(function(){
	if( jQuery('.product-detail').height() < jQuery('.product-detail .vertical-label > span').width() ){
		jQuery('.product-detail').height( jQuery('.product-detail .vertical-label > span').width() )
	}
});
